(function ($) {
    var PdfViewer = function (element, options) {
        this.container = $(element)[0];
        this.settings = $.extend({
            url: '',
            scale: 1, // Best quality scale
            minScale: 0.5,
            maxScale: 4.0,
            zoomSteps: [0.5, 0.75, 1, 1.25, 1.5, 2, 3, 4], // Predefined zoom levels
            zoomStep: 0.25,
            downloadFilename: 'document.pdf' // Default file name for download
        }, options);

        this.pdfTextContainer = document.createElement('div');
        this.pdfTextContainer.style.display = 'none';
        this.container.parentNode.insertBefore(this.pdfTextContainer, this.container.nextSibling);

        this.scale = this.settings.scale;
        this.pdfDoc = null;
        this.pageRenderingQueue = [];
        this.pageNum = 1;
        this.firstLoad = 1;
        this.pageRenderTasks = new Map(); // Track ongoing render tasks
        this.renderedPagesCount = 0; // Track number of rendered pages

        this.isDragging = false;
        this.startX = 0;
        this.scrollLeft = 0;

        this.init();
    };

    PdfViewer.prototype.init = function () {
        var self = this;

        $(self.container).on('scroll', function () {
            self.lazyRender();
            self.updatePageNumberOnScroll();
        });

        pdfjsLib.getDocument(self.settings.url).promise.then(function (pdfDoc) {
            self.pdfDoc = pdfDoc;
            self.renderUI(false);
            $('#page-info').text(`of ${self.pdfDoc.numPages}`);
        }).catch(function (error) {
            console.error('Error loading PDF:', error);
        });

        // Add drag functionality
        $(self.container).on('mousedown', self.startDrag.bind(self));
        $(self.container).on('mousemove', self.dragging.bind(self));
        $(self.container).on('mouseup', self.stopDrag.bind(self));
        $(self.container).on('mouseleave', self.stopDrag.bind(self));
    };

    PdfViewer.prototype.startDrag = function (event) {
        this.isDragging = true;
        this.startX = event.pageX - this.container.offsetLeft;
        this.scrollLeft = this.container.scrollLeft;
    };

    PdfViewer.prototype.dragging = function (event) {
        if (!this.isDragging) return;
        event.preventDefault();
        const x = event.pageX - this.container.offsetLeft;
        const walk = (x - this.startX) * 2; // Scroll fast
        this.container.scrollLeft = this.scrollLeft - walk;
    };

    PdfViewer.prototype.stopDrag = function () {
        this.isDragging = false;
    };

    PdfViewer.prototype.renderUI = function ($notInitialCall = true) {
        var self = this;
        for (var i = 1; i <= self.pdfDoc.numPages; i++) {
            self.createPlaceholder(i);
            self.pageRenderingQueue.push({ pageNumber: i, rendered: false });
        }

        self.renderedPagesCount = 0; // Reset rendered pages count

        self.loadPages().then(() => {
            if($notInitialCall){
                $('#loading-screen').hide();
                $('#responsive-container').show();                
            }
            self.lazyRender();
        }).then(() => {
            if(!$notInitialCall){    
                self.firstLoad = 0;            
                $('#loading-screen').hide();
                $('#responsive-container').show();
                self.setZoom('page-width');
            }
        }).catch(function (error) {
            console.error('Error rendering pages:', error);
        });
    };

    PdfViewer.prototype.createPlaceholder = function (pageNumber) {
        var div = document.createElement('div');
        div.className = 'pdf-page';
        div.dataset.pageNumber = pageNumber;

        // Canvas for visual rendering
        var canvas = document.createElement('canvas');
        canvas.className = 'pdf-canvas';
        div.appendChild(canvas);

        // Hidden text layer for SEO
        var textDiv = document.createElement('div');
        textDiv.className = 'text-layer';
        textDiv.dataset.pageNumber = pageNumber;
        textDiv.style.position = 'absolute';
        textDiv.style.left = '0';
        textDiv.style.top = '0';
        textDiv.style.width = '100%';
        textDiv.style.overflow = 'hidden'; // Hide overflow to prevent interference
        textDiv.style.pointerEvents = 'none'; // Ignore mouse events
        textDiv.style.opacity = '0'; // Hide from view

        div.appendChild(textDiv);
        this.container.appendChild(div);
    };

    PdfViewer.prototype.cancelRendering = function (canvas) {
        if (this.pageRenderTasks.has(canvas)) {
            this.pageRenderTasks.get(canvas).cancel();
            this.pageRenderTasks.delete(canvas);
        }
    };

    PdfViewer.prototype.renderPage = function (pageNumber, scale) {
        var self = this;
        const totalPages = this.pdfDoc.numPages;

        // Ensure correct canvas element
        var div = $(`.pdf-page[data-page-number=${pageNumber}]`)[0];
        if (!div) return;

        var canvas = div.querySelector('.pdf-canvas');
        var textDiv = div.querySelector('.text-layer');
        if (!canvas) return;

        // Cancel any ongoing render task for this canvas
        self.cancelRendering(canvas);

        var ctx = canvas.getContext('2d');
        return self.pdfDoc.getPage(pageNumber).then(function (page) {
            var viewport = page.getViewport({ scale: scale });
            canvas.height = viewport.height;
            canvas.width = viewport.width;

            canvas.style.height = `${viewport.height}px`;  // Ensure correct rendering size
            canvas.style.width = `${viewport.width}px`;    // Ensure correct rendering size
            textDiv.style.height = `${viewport.height}px`;
            textDiv.style.width = `${viewport.width}px`;

            var renderContext = {
                canvasContext: ctx,
                viewport: viewport,
            };

            var renderTask = page.render(renderContext);
            self.pageRenderTasks.set(canvas, renderTask); // Track this render task

            return renderTask.promise.then(function () {
                self.pageRenderTasks.delete(canvas); // Remove finished task from the map
                self.pageRenderingQueue.find(entry => entry.pageNumber === pageNumber).rendered = true;
                self.renderedPagesCount++;
                self.updateLoadingProgress(totalPages);
            }).then(function() {
                return page.getTextContent().then(function(textContent) {
                    self.renderTextContent(textContent, textDiv, viewport);
                });
            });
        }).catch(function (error) {
            console.error(`Error rendering page ${pageNumber}:`, error);
        });
    };

    PdfViewer.prototype.renderTextContent = function (textContent, textDiv, viewport) {
        // Disable user selection to avoid conflicts with text selection
        textDiv.style.height = viewport.height + 'px';
        textDiv.style.width = viewport.width + 'px';

        var textLayerFrag = document.createDocumentFragment();
        textContent.items.forEach(function (textItem) {
            var span = document.createElement('span');
            span.textContent = textItem.str;
            var transform = pdfjsLib.Util.transform(
                pdfjsLib.Util.transform(viewport.transform, textItem.transform),
                [1, 0, 0, -1, 0, 0]
            );

            var left = Math.floor(transform[4]);
            var top = Math.floor(transform[5]);
            span.style.left = Math.floor(left) + 'px';
            span.style.top = Math.floor(top) + 'px';
            span.style.fontSize = textItem.height + 'px';
            span.style.transform = `scaleX(${transform[0].toFixed(2)})`;
            span.classList.add('text-layer-item');
            textLayerFrag.appendChild(span);
        });

        textDiv.appendChild(textLayerFrag);
    };

    PdfViewer.prototype.updateLoadingProgress = function (totalPages) {
        if(this.firstLoad)
            totalPages = parseInt(totalPages + ((totalPages*28)/100) );

        const progress = Math.floor((this.renderedPagesCount / totalPages) * 100);
        $('#progress-fill').css('width', progress + '%');
        $('#progress-percent').text(progress + '%');
    };

    PdfViewer.prototype.lazyRender = function () {
        var self = this;
        var scrollTop = $(self.container).scrollTop();
        var containerHeight = $(self.container).height();

        self.pageRenderingQueue.forEach(function (entry) {
            var div = $(`.pdf-page[data-page-number=${entry.pageNumber}]`)[0];
            var rect = div.getBoundingClientRect();
            var pageTop = rect.top;
            var pageBottom = rect.bottom;

            if (!entry.rendered && pageBottom >= 0 && pageTop <= containerHeight) {
                self.renderPage(entry.pageNumber, self.scale).then(function () {
                    entry.rendered = true;
                });
            }
        });
    };

    PdfViewer.prototype.updatePageNumberOnScroll = function () {
        var self = this;
        var scrollTop = $(self.container).scrollTop();
        var containerHeight = $(self.container).height();
        var currentPage = self.pageNum;

        self.pageRenderingQueue.forEach(function (entry) {
            var div = $(`.pdf-page[data-page-number=${entry.pageNumber}]`)[0];
            if (div) {
                var rect = div.getBoundingClientRect();
                if (rect.top >= 0 && rect.top < containerHeight) {
                    currentPage = entry.pageNumber;
                }
            }
        });

        if (self.pageNum !== currentPage) {
            self.pageNum = currentPage;
            $('#page-number').val(self.pageNum);
        }
    };

    PdfViewer.prototype.loadPages = async function () {
        var self = this;
        const promises = self.pageRenderingQueue.map(entry => self.renderPage(entry.pageNumber, self.scale));
        for (const promise of promises) {
            await promise;
        }
    };

    PdfViewer.prototype.downloadPDF = function () {
        var link = document.createElement('a');
        link.href = this.settings.url;
        link.download = this.settings.downloadFilename;
        link.setAttribute('target', '_blank');
        link.click();
    };

    PdfViewer.prototype.zoomIn = function () {
        var self = this;
        var currentScaleIndex = self.settings.zoomSteps.indexOf(self.scale);
        if (currentScaleIndex < self.settings.zoomSteps.length - 1) {
            self.scale = self.settings.zoomSteps[currentScaleIndex + 1];
            self.updateZoom(true);
        }
    };

    PdfViewer.prototype.zoomOut = function () {
        var self = this;
        var currentScaleIndex = self.settings.zoomSteps.indexOf(self.scale);
        if (currentScaleIndex > 0) {
            self.scale = self.settings.zoomSteps[currentScaleIndex - 1];
            self.updateZoom(true);
        }
    };

    PdfViewer.prototype.setNumericZoom = function (zoomValue) {
        var self = this;
        self.scale = parseFloat(zoomValue);
        self.updateZoom(true);
    };

    PdfViewer.prototype.setZoom = function (zoomType) {
        var self = this;
        switch (zoomType) {
            case 'page-actual':
                self.scale = 1;
                self.updateZoom(true);
                break;
            case 'page-fit':
                var containerHeight = $(self.container).height();
                self.pdfDoc.getPage(self.pageNum).then(function (page) {
                    var viewport = page.getViewport({ scale: 1 });
                    self.scale = containerHeight / viewport.height;                    
                    self.updateZoom(true);
                });
                break;
            case 'page-width':
                var containerWidth = $(self.container).width();
                self.pdfDoc.getPage(self.pageNum).then(function (page) {
                    var viewport = page.getViewport({ scale: 1 });
                    self.scale = containerWidth / viewport.width;
                    self.updateZoom(true);
                });
                break;
            case 'auto':
            default:
                self.automaticZoom();
                break;
        }
    };

    PdfViewer.prototype.automaticZoom = function () {
        var self = this;
        var containerWidth = $(self.container).width();
        self.pdfDoc.getPage(self.pageNum).then(function (page) {
            var viewport = page.getViewport({ scale: 1 });
            self.scale = containerWidth / viewport.width;
            self.updateZoom(true);
        });
    };

    PdfViewer.prototype.updateZoom = function (showLoading) {
        var self = this;

        if (showLoading) {
            $('#loading-screen').show();
            $('#responsive-container').hide();
        }

        self.renderedPagesCount = 0; // Reset rendered pages count

        self.loadPages().then(() => {
            if (showLoading) {
                $('#loading-screen').hide();
                $('#responsive-container').show();
            }
            self.updatePageNumberOnScroll(); // Ensure page number is updated
        });
    };

    PdfViewer.prototype.prevPage = function () {
        if (this.pageNum > 1) {
            this.scrollToPage(this.pageNum - 1);
        }
    };

    PdfViewer.prototype.nextPage = function () {
        if (this.pageNum < this.pdfDoc.numPages) {
            this.scrollToPage(this.pageNum + 1);
        }
    };

    PdfViewer.prototype.scrollToPage = function (pageNumber) {
        var self = this;
        if (pageNumber > 0 && pageNumber <= self.pdfDoc.numPages) {
            self.pageNum = pageNumber;
            var pageDiv = $(`.pdf-page[data-page-number=${pageNumber}]`)[0];
            if (pageDiv) {
                $(self.container).animate({
                    scrollTop: $(pageDiv).offset().top + $(self.container).scrollTop() - $(self.container).offset().top
                }, 300, function () {
                    self.lazyRender(); // Ensure the new page is rendered if not already
                });
                $('#page-number').val(self.pageNum);
            }
        }
    };

    $.fn.pdfViewer = function (methodOrOptions) {
        var instance = $(this).data('pdfViewer');

        if (typeof methodOrOptions === 'object' || !methodOrOptions) {
            if (!instance) {
                instance = new PdfViewer(this, methodOrOptions);
                $(this).data('pdfViewer', instance);
            }
        } else {
            if (instance && typeof instance[methodOrOptions] === 'function') {
                return instance[methodOrOptions].apply(instance, Array.prototype.slice.call(arguments, 1));
            }
        }
    };
}(jQuery));